import type { ConsolidatedPlotCurrentStatusEnum } from '#backend/entity/loaded/harvest-monitoring/ConsolidatedPlotCurrentStatus';

export function getPlotStatusName(
  status?: ConsolidatedPlotCurrentStatusEnum | null,
  cultureName?: string | null,
) {
  const effectiveCulture = cultureName ?? 'Cultura alvo';
  const names = {
    possibly_target_culture: `Possível ${effectiveCulture}`,
    developing: `${effectiveCulture} em desenvolvimento`,
    senescence: `${effectiveCulture} em senescência`,
    ready_for_harvest: `${effectiveCulture} apto para a colheita`,
    harvested: 'Colhido',
    divergent_culture: 'Cultura divergente',
    not_planted: 'Não plantado',
    awaiting_identification: 'Aguardando identificação da cultura',
    awaiting_planting: 'Aguardando plantio',
  } as const satisfies Record<ConsolidatedPlotCurrentStatusEnum, string>;
  if (status && names[status]) {
    return names[status];
  } else {
    return undefined;
  }
}

export function getStatusColorRgb(
  s: ConsolidatedPlotCurrentStatusEnum,
): readonly [number, number, number] {
  const colors = {
    awaiting_planting: [227, 242, 253], // azul claro
    possibly_target_culture: [165, 245, 122], // verde marca-texto
    developing: [0, 212, 87], // verde-lima
    senescence: [184, 204, 61], // verde-musgo
    ready_for_harvest: [217, 194, 163], // bege
    harvested: [255, 234, 190], //colhido
    divergent_culture: [255, 194, 201], // rosa
    not_planted: [204, 204, 204], // cinza
    awaiting_identification: [255, 255, 255], // branco
  } as const;
  return colors[s];
}
